import React from 'react'

import { Field } from 'formik'

import { Col, Form, Button } from '_zari/core'

import {
  TiposDocumentoSunatConstant,
  OrigenesContabilidadConstant,
  TiposTablaComunConstant
} from 'constants/index'

import { KeyEventUtil } from 'utils'

import * as TablasComunesService from 'services/tablasComunes.service'

const TipoDocumentoFormGroup = ({
  iOrigen,
  iError,
  iTouched,
  iValue,
  fIsSubmitting,
  setFieldValue,
  handleChange
}) => {
  const [mostrarAyuda, setMostrarAyuda] = React.useState(false)
  const [documentosOptions, setDocumentosOptions] = React.useState([])
  const [documentosCompra, setDocumentosCompra] = React.useState([])

  const selectRef = React.useRef(null)

  React.useEffect(() => {
    if (iOrigen === OrigenesContabilidadConstant.COMPRAS) {
      TablasComunesService.getAsSelect(TiposTablaComunConstant.DOCUMENTOSUNAT).then(({ data }) => {
        if (data && data.length > 0) {
          setDocumentosCompra(data)
          setDocumentosOptions(
            data.map((x, k) => (
              <option key={k} value={x._id}>
                {x.nombre}
              </option>
            ))
          )
        }
      })
    } else {
      setDocumentosOptions(
        //PUSHING - CONTASOFT
        TiposDocumentoSunatConstant.__akdemicArray.map((x, k) => (
        // TiposDocumentoSunatConstant.__array.map((x, k) => (
          <option key={k} value={x.id}>
            {x.nombre}
          </option>
        ))
      )
    }
  }, [iOrigen])

  const tipoDocumentoText = React.useMemo(() => {
    if (iOrigen === OrigenesContabilidadConstant.COMPRAS) {
      const matchDoc = documentosCompra.find(x => x._id === iValue)

      if (matchDoc) {
        return matchDoc.nombre
      } else {
        return '--'
      }
    } else {
      switch (iValue) {
        case TiposDocumentoSunatConstant.OTROS:
          return TiposDocumentoSunatConstant.__dictionary[TiposDocumentoSunatConstant.OTROS].nombre
        case TiposDocumentoSunatConstant.FACTURA:
          return TiposDocumentoSunatConstant.__dictionary[TiposDocumentoSunatConstant.FACTURA]
            .nombre
        case TiposDocumentoSunatConstant.BOLETA:
          return TiposDocumentoSunatConstant.__dictionary[TiposDocumentoSunatConstant.BOLETA].nombre
        case TiposDocumentoSunatConstant.LIQUIDACION_DE_COMPRAS:
          return TiposDocumentoSunatConstant.__dictionary[
            TiposDocumentoSunatConstant.LIQUIDACION_DE_COMPRAS
          ].nombre
        case TiposDocumentoSunatConstant.NOTA_CREDITO:
          return TiposDocumentoSunatConstant.__dictionary[TiposDocumentoSunatConstant.NOTA_CREDITO]
            .nombre
        case TiposDocumentoSunatConstant.NOTA_DEBITO:
          return TiposDocumentoSunatConstant.__dictionary[TiposDocumentoSunatConstant.NOTA_DEBITO]
            .nombre
        case TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE:
          return TiposDocumentoSunatConstant.__dictionary[
            TiposDocumentoSunatConstant.GUIA_REMISION_REMITENTE
          ].nombre
        case TiposDocumentoSunatConstant.GUIA_REMISION_TRANSPORTISTA:
          return TiposDocumentoSunatConstant.__dictionary[
            TiposDocumentoSunatConstant.GUIA_REMISION_TRANSPORTISTA
          ].nombre
        default:
          return '--'
      }
    }
  }, [iValue, iOrigen, documentosCompra])

  const clickAyuda = React.useCallback(() => {
    setMostrarAyuda(true)
  }, [])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-serieDocumento', e)
  }, [])

  const onSelectKeyDown = React.useCallback(e => {
    if (e.keyCode === 13 || e.keyCode === 9) {
      e.preventDefault()
      setMostrarAyuda(false)
      KeyEventUtil.leaveOnKeyEvent('input-serieDocumento')
    }
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      setFieldValue('serieDocumento', '')
      setFieldValue('codigoAduana', '')
    },
    [handleChange, setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='TIPO DOC.' htmlFor='input-tipoDocumento' md={12} />
      <Col md={5}>
        {mostrarAyuda ? (
          <Field name='tipoDocumento'>
            {({ field }) => (
              <Form.Select
                {...field}
                onChange={onChange}
                ref={selectRef}
                id='select-tipoDocumento'
                isInvalid={iTouched && iError}
                disabled={fIsSubmitting}
                onKeyDown={onSelectKeyDown}
              >
                <option value=''>Seleccionar</option>
                {documentosOptions}
              </Form.Select>
            )}
          </Field>
        ) : (
          <Form.InputGroup>
            <Field name='tipoDocumento'>
              {({ field }) => (
                <Form.InputText
                  {...field}
                  onChange={onChange}
                  id='input-tipoDocumento'
                  isInvalid={iTouched && iError}
                  disabled={fIsSubmitting}
                  onKeyDown={onKeyDown}
                  maxLength={2}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={clickAyuda}>&#x1F892;</Button>
            </Form.InputGroup.Append>
            {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
          </Form.InputGroup>
        )}
      </Col>
      <Col md={7}>
        <Form.OnlyText text={tipoDocumentoText} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoDocumentoFormGroup)
